module.exports = __webpack_public_path__ + "img/dldh.06bf900b.webp";